import React from 'react';
import { Card, Table, Row, Col, Statistic, Tag } from 'antd';
import { DollarOutlined, WarningOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import { portfolioAPI } from '../api/endpoints';
import { formatCurrency, formatDate } from '../utils/helpers';

const PortfolioPage = () => {
  const { data: analysisData } = useQuery('portfolio-analysis', () => portfolioAPI.getAnalysis());
  const { data: reportData } = useQuery('portfolio-reports', () => portfolioAPI.getReports());

  const analysis = analysisData?.data?.results || [];
  const report = reportData?.data?.results?.[0] || {};

  const bucketColumns = [
    {
      title: 'Factura',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
    },
    {
      title: 'Cliente',
      dataIndex: 'customer_name',
      key: 'customer_name',
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => formatCurrency(amount),
    },
    {
      title: 'Días de Atraso',
      dataIndex: 'days_overdue',
      key: 'days_overdue',
      render: (days) => (
        <Tag color={days > 90 ? 'red' : days > 60 ? 'orange' : 'default'}>
          {days} días
        </Tag>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Total Pendiente"
              value={report?.total_pending || 0}
              prefix={<DollarOutlined />}
              formatter={(value) => formatCurrency(value)}
              valueStyle={{ color: '#667eea' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Total Vencido"
              value={report?.total_overdue || 0}
              prefix={<WarningOutlined />}
              formatter={(value) => formatCurrency(value)}
              valueStyle={{ color: '#f5222d' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Facturas Vencidas"
              value={report?.number_of_overdue_invoices || 0}
              valueStyle={{ color: '#f5222d' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Días Promedio de Atraso"
              value={report?.average_days_overdue || 0}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 24 }} title="Análisis de Cartera">
        <Table
          dataSource={analysis}
          columns={bucketColumns}
          rowKey="id"
          scroll={{ x: 800 }}
        />
      </Card>
    </div>
  );
};

export default PortfolioPage;
